module.exports = __webpack_public_path__ + "static/media/sb_city_college_logo.6d7d4e6b.jpg";